<template>
  <div>
    <div class="filter-dropdown-container">
      <p class="filter-dropdown-container__label">{{ label }}</p>
      <div class="filter-dropdown" v-clickoutside="closeDropdown">
        <button
          aria-haspopup="listbox"
          class="filter-dropdown__selected"
          @click="toggleDropdown"
        >
          {{ selectLabel }}
          <span class="filter-chevron-icon">
            <slot name="chevronIcon"></slot>
          </span>
        </button>
        <div class="filter-dropdown-dropdown" :class="{ hide: !open }">
          <div class="filter-dropdown-dropdown-body" ref="dropdownBody">
            <div
              :key="filterGroup.title"
              v-for="filterGroup in internalFilterGroups"
            >
              <h4 class="filter-dropdown-dropdown-body__title">
                <strong>{{ filterGroup.title }}</strong>
              </h4>
              <div class="filter-dropdown-dropdown-body-options">
                <button
                  aria-label="Toggle filter"
                  class="filter-dropdown-dropdown-body-options__option"
                  :key="filter.id"
                  v-for="filter in filterGroup.values"
                  @click="selectFilter(filter)"
                  :class="{ 'selected-filter': filter.checked }"
                >
                  {{ filter.name }}
                </button>
              </div>
            </div>
          </div>

          <button
            aria-label="Close Filter Dropdown"
            :class="{
              'filter-dropdown-dropdown__close-btn--margin-right': bodyOverflow,
            }"
            class="filter-dropdown-dropdown__close-btn"
          >
            <span @click="closeDropdown" class="filter-close-icon">
              <slot name="closeIcon"></slot>
            </span>
          </button>

          <div class="filter-dropdown-dropdown-footer">
            <button
              class="filter-dropdown-dropdown-footer__apply-btn"
              @click="applyFilters"
              type="button"
            >
              {{ applyBtnLabel }}
            </button>
            <button
              class="filter-dropdown-dropdown-footer__clear-btn"
              @click="removeAllFilters"
              type="button"
            >
              <span class="filter-close-icon">
                <slot name="closeIcon"></slot>
              </span>
              {{ clearBtnLabel }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { clickoutside } from "@Foundation/directives/clickoutside/clickoutside";

  export default {
    name: "search-filter",
    directives: {
      clickoutside,
    },
    props: {
      label: {
        type: String,
        default: "FILTER BY",
      },
      selectLabel: {
        type: String,
        default: "FILTER BY",
      },
      filterGroups: {
        type: Array,
        required: true,
      },
      clearBtnLabel: {
        type: String,
        required: false,
        default: "CLEAR ALL",
      },
      applyBtnLabel: {
        type: String,
        required: false,
        default: "APPLY",
      },
    },
    data() {
      return {
        open: false,
        internalFilterGroups: [],
        bodyOverflow: false,
      };
    },

    mounted() {
      this.internalFilterGroups = this.filterGroups;
    },

    methods: {
      applyFilters: function () {
        this.closeDropdown();
        this.$emit("filters-changed", this.internalFilterGroups);
      },

      selectFilter: function (selectedFilter) {
        selectedFilter.checked = !selectedFilter.checked;
      },

      removeAllFilters: function () {
        this.internalFilterGroups.forEach((filterGroup) => {
          filterGroup.values.forEach((filter) => {
            filter.checked = false;
          });
        });
        this.applyFilters();
      },

      toggleDropdown: function () {
        this.open = !this.open;
        if (this.open) {
          this.internalFilterGroups = this.filterGroups;
          document.body.classList.add("body-hide-overflow");
          setTimeout(() => {
            this.checkBodyOverflow();
          }, 1);
        }
      },

      closeDropdown: function () {
        this.open = false;
        document.body.classList.remove("body-hide-overflow");
      },

      checkBodyOverflow() {
        if (
          this.$refs.dropdownBody.scrollHeight >
          this.$refs.dropdownBody.clientHeight
        ) {
          this.bodyOverflow = true;
        }
      },
    },
  };
</script>

<style src="./FilterDropdown.scss" lang="scss"></style>
